// extracted by mini-css-extract-plugin
export var headerXL = "SectionLeadership-module--headerXL--1ymiu";
export var headerL = "SectionLeadership-module--headerL--3o1HD";
export var headerM = "SectionLeadership-module--headerM--3Wzgh";
export var headerS = "SectionLeadership-module--headerS--oJVyG";
export var headerXS = "SectionLeadership-module--headerXS--rs2pB";
export var blogHeaderXL = "SectionLeadership-module--blogHeaderXL--3ZMA8";
export var blogHeaderL = "SectionLeadership-module--blogHeaderL--3hVeF";
export var blogHeaderM = "SectionLeadership-module--blogHeaderM--EK2Nm";
export var blogHeaderS = "SectionLeadership-module--blogHeaderS--6sg1M";
export var blogHeaderXS = "SectionLeadership-module--blogHeaderXS--2iBrb";
export var headerPreamble = "SectionLeadership-module--headerPreamble--3fcHF";
export var preHeader = "SectionLeadership-module--preHeader--Jf8MZ";
export var textNormal = "SectionLeadership-module--textNormal--2CLR8";
export var textSmall = "SectionLeadership-module--textSmall--3zusb";
export var textSmallAlternate = "SectionLeadership-module--textSmallAlternate--3SMIm";
export var legend = "SectionLeadership-module--legend--28z1K";
export var caption = "SectionLeadership-module--caption--2oH5e";
export var gradientBackground = "SectionLeadership-module--gradientBackground--2nG1h";
export var ellipsis = "SectionLeadership-module--ellipsis--lF3Mu";
export var globalContainer = "SectionLeadership-module--globalContainer--Wll9h";
export var maxWidth = "SectionLeadership-module--maxWidth--1wjet";
export var clipBottom = "SectionLeadership-module--clipBottom--1k9Zq";
export var clipTopBottom = "SectionLeadership-module--clipTopBottom--BKKV_";
export var container = "SectionLeadership-module--container--1Z8Rw";
export var contentContainer = "SectionLeadership-module--contentContainer--1FtS6";
export var sectionTitle = "SectionLeadership-module--sectionTitle--1PAXB";
export var cardContainer = "SectionLeadership-module--cardContainer--LYK51";
export var cardPadding = "SectionLeadership-module--cardPadding--Y22xe";
export var name = "SectionLeadership-module--name--38xK2";
export var title = "SectionLeadership-module--title--3-g5F";
export var bio = "SectionLeadership-module--bio--3cZ22";
export var avatar = "SectionLeadership-module--avatar--34BlW";
export var placeholderAvatarImage = "SectionLeadership-module--placeholderAvatarImage--1FmZZ";
export var ch2 = "SectionLeadership-module--ch2--2FOCs";
export var ch2Container = "SectionLeadership-module--ch2-container--2ATDQ";